// extracted by mini-css-extract-plugin
export default {"select":"styles_select__4DhtN","disabled":"styles_disabled__+Qhib"};